export const CONTENT_HOME_SET = 'CONTENT_SET';
export const CONTENT_HOME_GET = 'CONTENT_GET';
export const CONTENT_FETCH_ACTION = 'CONTENT_FETCH_ACTION';

export const SELECTED_REGION_SET = 'SELECTED_REGION_SET';
export const SELECTED_REGION_GET = 'SELECTED_REGION_GET';
export const SELECTED_REGION_ACTION = 'SELECTED_REGION_ACTION';
